import PageLoader from '@/components/common/PageLoader'
import { useProviderCatalog } from '@/providers/useProviderCatalog'

/**
 * Render `element` only when this tenant's provider catalog lists `providerKey`.
 * A flagged-off provider is absent from the catalog, so its guided setup
 * gets `fallback` (the standard 404) instead of a page the backend would
 * refuse. Waits for the catalog first so an enabled provider never flashes
 * the fallback.
 *
 * @param {Object} props
 * @param {string} props.providerKey - the provider key the route belongs to
 * @param {JSX.Element} props.element - rendered when the provider is listed
 * @param {JSX.Element} props.fallback - rendered when it is not, or the catalog fails
 * @returns {JSX.Element}
 */
export default function ProviderRouteGuard({ providerKey, element, fallback }) {
  const { byKey, isLoading } = useProviderCatalog()
  if (isLoading) return <PageLoader />
  return byKey[providerKey] ? element : fallback
}
